import { createContext, useContext } from 'react';

export const RingLayoutContext = createContext<string>('');

const useLayoutDimensions = () => useContext(RingLayoutContext);

export default useLayoutDimensions;
